// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    overflow: auto;
}

.item {
    width: 100%;
    height: 40px;
}
.item:hover {
    background-color: rgba(0,0,0,0.1);
}

.item-text {
    width: 500px;
    position: relative;
    display: inline-block;
    overflow: hidden; 
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item-text div {
    display: inline-block;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    /* word-wrap: break-word; */
    white-space: nowrap;
}

.item-property {
    position: relative;
    /* left: 400px; */
    width: 400px;
    display: inline-block;
    overflow: hidden; 
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 40px;
}

.item-info {
    position: relative;
    /* left: 400px; */
    width: 200px;
    display: inline-block;
    overflow: hidden; 
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 40px;
}

.item-check {
    float: right;
    margin-right: 20px;
    line-height: 32px;
    /* display: inline-block; */
}

.item-waiting {
    /* -moz-transition: height .5s;
    -ms-transition: height .5s;
    -o-transition: height .5s;
    -webkit-transition: height .5s;
    transition: height .5s; */
    display:inline-block;
    height: 40;
    vertical-align: middle;
    /* width: 80%; */
    overflow: hidden;
}
   `, "",{"version":3,"sources":["webpack://./src/app/gui-helpers/treetable/treetable.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI;;;;6BAIyB;IACzB,oBAAoB;IACpB,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".container {\n    overflow: auto;\n}\n\n.item {\n    width: 100%;\n    height: 40px;\n}\n.item:hover {\n    background-color: rgba(0,0,0,0.1);\n}\n\n.item-text {\n    width: 500px;\n    position: relative;\n    display: inline-block;\n    overflow: hidden; \n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.item-text div {\n    display: inline-block;\n    overflow-wrap: break-word;\n    text-overflow: ellipsis;\n    /* word-wrap: break-word; */\n    white-space: nowrap;\n}\n\n.item-property {\n    position: relative;\n    /* left: 400px; */\n    width: 400px;\n    display: inline-block;\n    overflow: hidden; \n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 40px;\n}\n\n.item-info {\n    position: relative;\n    /* left: 400px; */\n    width: 200px;\n    display: inline-block;\n    overflow: hidden; \n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 40px;\n}\n\n.item-check {\n    float: right;\n    margin-right: 20px;\n    line-height: 32px;\n    /* display: inline-block; */\n}\n\n.item-waiting {\n    /* -moz-transition: height .5s;\n    -ms-transition: height .5s;\n    -o-transition: height .5s;\n    -webkit-transition: height .5s;\n    transition: height .5s; */\n    display:inline-block;\n    height: 40;\n    vertical-align: middle;\n    /* width: 80%; */\n    overflow: hidden;\n}\n   "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
